import axios from 'axios';
import router from '../../router/index';

const state = {
	token: localStorage.getItem('token') || '',
	hasLoadedOnce: false,
	loading: false
};

const getters = {
	getToken: (state) => state.token,
	isAuthenticated: (state) => !!state.token,
	authStatus: (state) => state.status
};

const mutations = {
	setLoading: (state, value) => {
		state.loading = value;
	},
	setToken: (state, value) => {
		state.token = value;
	}
};

const actions = {
	async login({ commit, dispatch }, credentials) {
		commit('setLoading', true);
		try {
			const res = await axios.post('/login.php', { ...credentials });
			localStorage.setItem('token', res.data.jwt);
			commit('setToken', res.data.jwt);
			dispatch(
				'ui/makeToast',
				{
					title: 'inicio de sesión exitoso.'
				},
				{ root: true }
			);
			router.push('/panel');
		} catch (err) {
			localStorage.removeItem('token'); // if the request fails, remove any possible user token if possible
			switch (err.response.status) {
				case 401:
					dispatch(
						'ui/makeToast',
						{
							icon: 'warning',
							title: 'Usuario y/o contraseña incorrectos.'
						},
						{ root: true }
					);
					break;
			}
		} finally {
			commit('setLoading', false);
		}
	},
	logout() {
		localStorage.removeItem('token');
		router.push('/master-login');
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
